var makeString = require('./helper/makeString');

module.exports = function truncate(str, length, truncateStr) {
  str = makeString(str);
  truncateStr = truncateStr || '...';
  length = ~~length;
  return str.length > length ? str.slice(0, length) + truncateStr : str;
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/truncate.js
// module id = 1654
// module chunks = 0